module.exports = __webpack_public_path__ + "static/02-84e8e85d5b7d2b467f6b2cd334a97218.jpg";